import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TagPickerComponent } from "src/app/shared/components/tag-picker/tag-picker.component";
import { DataListTagGroup } from "src/app/shared/models/data-list";

export interface TagDialogData {
  availableTags: DataListTagGroup[];
  preselectedTagIds: string[];
  isStateUser: boolean;
}

@Component({
    selector: "app-tag-picker-modal",
    templateUrl: "./tag-picker-modal.component.html",
    styleUrls: ["./tag-picker-modal.component.scss"],
    standalone: false
})
export class TagPickerModalComponent implements OnInit {
  selectedTagsCount: number;

  @ViewChild(TagPickerComponent) tagPicker: TagPickerComponent;

  constructor(
    public dialogRef: MatDialogRef<TagPickerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TagDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(this.tagPicker.getSelectedTagIds());
  }

  ngOnInit(): void {
    this.selectedTagsCount = this.data.preselectedTagIds.length;
  }

  hasTagSelected() {
    return this.selectedTagsCount > 0;
  }

  selectedTagCountChanged(count: number) {
    this.selectedTagsCount = count;
  }
}
